module.exports = __webpack_public_path__ + "static/media/dribbble-icon.859858d2.svg";